import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import c1 from "../src/assets/c1.png";
import cd1 from "../src/assets/cd1.png";
import cd2 from "../src/assets/cd2.png";
import cd3 from "../src/assets/cd3.png";
import PhoneHeader from "../src/components/PhoneHeader";

const Contact = () => {
  const services = [
    "AEPS Service",
    "BBPS Service",
    "UPI ATM Service",
    "IT Technology Services",
    "Taxation Services",
    "ATM Installation Services",
    "Micro ATM Services",
    "Registration Services",
    "Adhar Pay Services",
    "API Integration Services",
  ];

  const [selectedServices, setSelectedServices] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [isChecked, setIsChecked] = useState(false); 

  const dropdownRef = useRef(null);

  const toggleService = (service) => {
    if (selectedServices.includes(service)) {
      setSelectedServices(selectedServices.filter((s) => s !== service));
    } else {
      setSelectedServices([...selectedServices, service]);
    }
  };

  const removeService = (service) => {
    setSelectedServices(selectedServices.filter((s) => s !== service));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess("");
    setError("");

    if (
      !name ||
      !email ||
      !mobile ||
      selectedServices.length === 0 ||
      !message
    ) {
      setError("Please fill all fields and select at least one service.");
      setLoading(false);
      return;
    }

    try {
      const payload = {
        name,
        email,
        mobile,
        services: selectedServices,
        message,
      };

      const response = await axios.post(
        "https://contact.singhtek.com/api/aepspay",
        payload,
      );

      if (response.status === 200) {
        setSuccess("Form submitted successfully!");
        // Clear form
        setName("");
        setEmail("");
        setMobile("");
        setSelectedServices([]);
        setMessage("");
      } else {
        setError("Something went wrong. Please try again later.");
      }
    } catch (err) {
      console.error(err);
      setError("Failed to submit form. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <PhoneHeader className="back" />
      <div>
        <div className="container space">
          <div className="text-center top-heading section">
            <h1>Contact Us</h1>
            <p className="mb-0">
              Withdraw, Deposit & Check Balance Instantly – Anytime, Anywhere.
            </p>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-6 m-md-0 mb-4">
            <div>
              <img src={c1} className="w-100 " />
            </div>
          </div>
          <div className="col-md-6">
            <div
              className="mb-5 py-4 px-md-5 px-3"
              style={{ borderRadius: "20px", border: "1px solid #D4D4D4" }}
            >
              {/* <h2 className="fw-bold mb-2">Get In Touch</h2>
              <p className="text-secondary mb-4">
                Vivamus elementum semper nisi.
              </p> */}

              <form onSubmit={handleSubmit}>
                {/* Name */}
                <div className="mb-3">
                  <label className="form-label fw-semibold">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>

                {/* Email */}
                <div className="mb-3">
                  <label className="form-label fw-semibold">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                {/* Mobile */}
                <div className="mb-3">
                  <label className="form-label fw-semibold">Phone Number</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="+91"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                  />
                </div>

                {/* Services */}
                <div className="mb-3 position-relative w-100" ref={dropdownRef}>
                  <label className="form-label fw-semibold">
                    Select Services
                  </label>
                  <div
                    className="form-control d-flex flex-wrap align-items-center"
                    style={{ minHeight: "50px", cursor: "pointer" }}
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                  >
                    {selectedServices.length === 0 ? (
                      <span className="text-muted">Select Services...</span>
                    ) : (
                      selectedServices.map((s, i) => (
                        <div
                          key={i}
                          className="d-flex align-items-center bg-light px-2 py-1 me-2 mb-1 rounded"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <span>{s}</span>
                          <span
                            className="ms-1"
                            style={{ cursor: "pointer", fontWeight: "bold" }}
                            onClick={() => removeService(s)}
                          >
                            ×
                          </span>
                        </div>
                      ))
                    )}
                    <span
                      className="ms-auto"
                      style={{
                        transform: dropdownOpen
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                        transition: "0.2s",
                      }}
                    >
                      ▼
                    </span>
                  </div>

                  {dropdownOpen && (
                    <div
                      className="position-absolute w-100 bg-white border rounded"
                      style={{
                        top: "100%",
                        left: 0,
                        zIndex: 999,
                        maxHeight: "200px",
                        overflowY: "auto",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                      }}
                    >
                      {services.map((service, index) => (
                        <div
                          key={index}
                          className={`d-flex align-items-center px-2 py-1 ${selectedServices.includes(service) ? "bg-light" : ""}`}
                          onClick={() => toggleService(service)}
                          style={{ cursor: "pointer" }}
                        >
                          <input
                            type="checkbox"
                            readOnly
                            checked={selectedServices.includes(service)}
                            className="me-2"
                          />
                          <span>{service}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Message */}
                <div className="mb-3">
                  <label className="form-label fw-semibold">Message</label>
                  <textarea
                    rows="5"
                    className="form-control"
                    placeholder="Type something..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </div>

                {/* Checkbox */}
                <div className="form-check mb-4">
  <input
    className="form-check-input"
    type="checkbox"
    id="terms"
    checked={isChecked}
    onChange={(e) => setIsChecked(e.target.checked)}
  />
  <label className="form-check-label" htmlFor="terms">
    I agree to{" "}
    <a href="#" className="text-primary text-decoration-none">
      Terms and Conditions.
    </a>
  </label>
</div>

                {/* Error / Success */}
                {error && <div className="text-danger mb-3">{error}</div>}
                {success && <div className="text-success mb-3">{success}</div>}

                {/* Submit Button */}
                <button
  type="submit"
  className="btn w-100 py-2 text-white"
  style={{
    background: "linear-gradient(to right, #FF7A60, #F2664A)",
    borderRadius: "20px",
  }}
  disabled={loading || !isChecked}
>
  {loading ? "Submitting..." : "Send Message"}
</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
